import { render, staticRenderFns } from "./WrapUp.vue?vue&type=template&id=40ac298d&scoped=true&"
import script from "./WrapUp.vue?vue&type=script&lang=ts&"
export * from "./WrapUp.vue?vue&type=script&lang=ts&"
import style0 from "./WrapUp.vue?vue&type=style&index=0&id=40ac298d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac298d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextarea})
